import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import Fuse from 'fuse.js';
import { useI18n } from '~Hooks';

const Wrapper = styled.div`
  width: 100%;
`;

const Input = styled.input`
  height: 64px;
  width: 100%;
  border-radius: 40px;
  border: 1px solid #c3c5c7;
  background-color: #fff;
  box-sizing: border-box;
  padding: 8px 16px;
  font-size: 18px;
  font-weight: 500;
  color: #1c232c;

  &:focus {
    border-color: #1c232c;
    outline: none;
  }
`;

const options = {
  minMatchCharLength: 1,
  threshold: 0.2,
};

interface Props {
  list: any[];
  keys: string[];
  setSearchResult: (list: any[]) => void;
}

const reformatSearchResult = (list: any[]) => {
  return list.map((i) => ({ ...i?.item }));
};

const SearchBar = ({ list, keys, setSearchResult }: Props) => {
  const { i18n } = useI18n();
  const [value, setValue] = useState('');

  const fuse = new Fuse(list, {
    ...options,
    keys,
  });
  const result = fuse.search(value);

  useEffect(() => {
    if (value) {
      setSearchResult(reformatSearchResult(result));
    } else {
      setSearchResult(list);
    }
  }, [value, list]);

  return (
    <Wrapper>
      <Input
        type="text"
        placeholder={i18n('Settings.Search.Placeholder')}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
    </Wrapper>
  );
};

export default SearchBar;
